import * as THREE from 'three';

const pinchScaleComponent = {
  schema: {
    min: { default: 0.3 },
    max: { default: 8 },
    sensitivity: { default: 0.01 },
  },
  init: function () {
    this.initialScale = this.el.object3D.scale.clone();
    this.initialPosition = this.el.object3D.position.clone();
    this.scaleFactor = 1;
    this.handleEvent = this.handleEvent.bind(this);
    this.el.sceneEl.addEventListener('twofingermove', this.handleEvent);
    const geometry = this.el.getObject3D('mesh')?.geometry;
    if (geometry) {
      if (!geometry.boundingBox) {
        geometry.computeBoundingBox();
      }
      this.boundingBoxSize = geometry.boundingBox.getSize(new THREE.Vector3());
    } else {
      this.boundingBoxSize = new THREE.Vector3(1, 1, 1); // Default size as a fallback
    }
  },
  remove: function () {
    this.el.sceneEl.removeEventListener('twofingermove', this.handleEvent);
  },

  handleEvent: function (event) {
    const scaleChange =
      1 +
      (event.detail.spreadChange / event.detail.startSpread) *
        this.data.sensitivity;
    this.scaleFactor *= scaleChange;

    // Clamp the scale factor to the specified range
    this.scaleFactor = THREE.MathUtils.clamp(
      this.scaleFactor,
      this.data.min,
      this.data.max
    );

    // Apply the new scale to the object
    this.el.object3D.scale.set(
      this.scaleFactor * this.initialScale.x,
      this.scaleFactor * this.initialScale.y,
      this.scaleFactor * this.initialScale.z
    );

    // Adjust position to maintain object height
    const deltaScale = this.el.object3D.scale.y - this.initialScale.y;
    const deltaY =
      deltaScale * this.boundingBoxSize.y * this.el.object3D.scale.y;

    this.el.object3D.position.y = this.initialPosition.y + deltaY;
  },
};

export { pinchScaleComponent };
